export const isPaid = (row) => Boolean(row.payout || row.paymentStatus === 'paid');

export const isSalaryAdvance = (row) => row.taxCardPayroll?.mode === 'salary_advance';

export const hasPayoutInputs = (row) => !isPaid(row) && !row.transferredOut && !row.taxCardPayroll?.error && (
  row.taxCardPayroll ? row.taxCardPayroll.hasPaymentInputs === true : (
    (Number.isFinite(Number(row.payableHours ?? row.adminHours)) && Number(row.payableHours ?? row.adminHours) !== 0)
    || [row.payablePremiumAmountOre ?? row.premieAmountDkk, row.payableForudbetalingOre ?? row.forudbetaling,
      row.payableRejseomkOre ?? row.rejseomk]
      .some((value) => Number(value) !== 0 && Number.isFinite(Number(value)))
  )
);

export const hasPayableInputs = (row) => hasPayoutInputs(row)
  || (!isPaid(row) && !row.transferredOut && !row.taxCardPayroll?.error && (row.taxCardPayroll
    ? Array.isArray(row.taxCardPayroll.exportLines) && row.taxCardPayroll.exportLines.length > 0
    : Number(row.feriedage) > 0));

export const forwardDestination = (row) => {
  const destination = row.transferDestination || row.forwardedTo || row.transferredTo;
  if (typeof destination === 'string') return destination;
  if (destination?.year && destination?.month) return `${destination.year}-${String(destination.month).padStart(2, '0')}`;
  return 'a later payroll month';
};

export const payrollReason = (row) => {
  if (row.transferredOut) return `Forwarded to ${forwardDestination(row)} · source changes flow to the next unpaid month; confirmed payouts stay fixed`;
  if (isPaid(row)) return `Paid ${row.payout?.paidDate || ''}${row.payout?.reference ? ` · ${row.payout.reference}` : ''}`.trim();
  if (row.employedInMonth || row.employedDuringMonth) return 'Employed during this month';
  return ({
    employed: 'Employed during this month',
    employment: 'Employed during this month',
    outstanding: 'Outstanding payroll inputs for this month',
    carried: 'Carried payroll inputs from previous months',
    carried_in: 'Carried payroll inputs from previous months',
  }[row.inclusionReason] || row.inclusionReason || row.payrollReason || 'Outstanding payroll inputs for this month');
};
